'use client'

import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  /* Fuentes movidas a styles/fonts.css para evitar parpadeos en Electron */

  :root {
    --font-roboto: 'Roboto', sans-serif;
    --font-squada: 'Squada One', cursive;
    --font-chakra: 'Chakra Petch', sans-serif;
  }

  body {
    background-color: #050208;
    color: #fff;
    font-family: var(--font-roboto);
    overflow: hidden;
    overflow-y: auto;
    min-width: 1288px !important;
  }

  /* Global Custom Scrollbars */
  * {
    scrollbar-width: thin;
    scrollbar-color: #6366f1 transparent;
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #6366f1;
    border-radius: 20px;
    border: 2px solid #050208;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #818cf8;
  }
  
  h1, h2, h3, h4, h5, h6 {
      font-family: var(--font-squada), cursive;
  }
  
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  div {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
  }

  button {
    cursor: pointer;
    background: none;
    border: none;
    outline: none;
    position: relative;
	  display: flex;
	  align-items: center;
	  justify-content: center;
  }

  /* MUI Tooltip Overrides */
  .MuiTooltip-tooltip {
    background-color: rgba(12, 12, 18, 0.98) !important;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    font-size: 12px !important;
    font-weight: 400 !important;
    padding: 12px 18px !important;
    border-radius: 8px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.5);
    color: #fff !important;
    font-family: var(--font-roboto), sans-serif !important;
  }

  .MuiTooltip-arrow {
    color: rgba(12, 12, 18, 0.98) !important;
  }
`

export default GlobalStyle
